import React from "react";

const AuthHeroImage = ({ imageUrls, slogans, slideIndex, overlayActive }) => {
  const imageIndex = slideIndex % imageUrls.length;
  const sloganIndex = slideIndex % slogans.length;

  return (
    <div
      className="image-section auth-image-section d-none d-md-block"
      style={{
        flex: 2,
        backgroundImage: `url(${imageUrls[imageIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="auth-image-watermark" aria-hidden="true">
        <div className="auth-image-watermark__strip">
          <p key={sloganIndex} className="auth-image-watermark__text" style={{ color: "#fff" }}>
            {slogans[sloganIndex]}
          </p>
        </div>
      </div>
      <div
        className="auth-image-overlay"
        style={{
          opacity: overlayActive ? 1 : 0,
          backdropFilter: overlayActive ? "blur(18px)" : "blur(0px)",
          background: overlayActive ? "rgba(0,0,0,0.7)" : "rgba(0,0,0,0.0)",
        }}
      />
    </div>
  );
};

export default AuthHeroImage;
